export const USERS = [
  {
    id: 1,
    firstName: 'David',
    lastName: 'Winn',
    role: 'individual',
    avatar: null,
  },
  {
    id: 2,
    firstName: 'David',
    lastName: 'Winn',
    role: 'individual',
    avatar: null,
  },
  {
    id: 3,
    firstName: 'David',
    lastName: 'Winn',
    role: 'individual',
    avatar: null,
  },
  {
    id: 4,
    firstName: 'David',
    lastName: 'Winn',
    role: 'individual',
    avatar: null,
  },
];
